export default __webpack_public_path__ + "static/media/chat-bubbles.d3d992b4.svg";